import {GameModel} from "@nolimit/slot-game/bin/model/GameModel";
import {ApiPlugin} from "@nolimit/slot-launcher/bin/plugins/ApiPlugin";
import {IFITH2GameData, IFITH2InitData} from "./IFITH2Data";
import {Logger} from "@nolimit/slot-launcher/bin/utils/Logger";
import {APIFeatureBetEventData} from "@nolimit/slot-launcher/bin/interfaces/APIBetEventData";
import {FireInTheHole2} from "../FireInTheHole2";
import {APIEvent} from "@nolimit/slot-launcher/bin/interfaces/APIEventSystem";
import {ISymbolData} from "../symbols/FITH2Symbol";
import {FITH2Helper} from "../utils/FITH2Helper";
import {IBetWayWinData} from "@nolimit/slot-game/bin/utils/server/IData";
import {MathHelper} from "@nolimit/slot-game/bin/utils/MathHelper";
import {ArrayHelper} from "@nolimit/slot-game/bin/utils/ArrayHelper";
import {NolimitConfig} from "@nolimit/slot-launcher/bin/settings/NolimitConfig";
import {APIBetType} from "@nolimit/slot-launcher/bin/interfaces/APIBetType";
import {FSSymbolTypes, IFsSymbolData} from "../symbols/freespin/FreespinSymbol";
import {FITH2GameConfig} from "../configs/FITH2GameConfig";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";

export interface IWildMiningGroup {
    linkedSymbol: string;
    symbols: number[][];
}

export interface IDynamiteData {
    dynamitePos: number[];
    throwPos: number[][];
}

export interface INecromancerData {
    necromancerPos: number[];
    necromancerHitPos: number[][];
}

export interface IReelMultiplier {
    multiplier: number;
    reelId: number;
    rId: number;
}

export interface IFSStepData {
    id: number;
    dynamites?: IDynamiteData;
    necromancer?: INecromancerData;
    reelMultiplier?: IReelMultiplier;
    collectorPos?: number[];
    endMultipliers: number[][];
    coinTypes: string[][];
}

export class FITH2Model extends GameModel<IFITH2InitData, IFITH2GameData> {

    private _isRestore: boolean;
    private _isBigWin: boolean;
    private _isNormal: boolean;
    private _isRespin: boolean;
    private _isNextNormal: boolean;
    private _isNextRespin: boolean;
    private _hasChestOpen: boolean;
    public freespinTriggeredThisSpin: boolean;
    public boostedBet: boolean;
    public nextPlayerInteraction: any;
    public currentWinRatio: number;
    public totalWays: number;
    private _buyFeatureName: string;
    public reels: string[][];
    public reelsData: ISymbolData[][];
    public fsReelsData: IFsSymbolData[][];
    public reelsFillUpData: ISymbolData[][];
    public fsFullFilledReels: boolean[];

    public wildOnReel: boolean[];
    public maxWinReelId: number;
    public barId: number;

    public allWinPositions: boolean[][];
    public allWinPositionSymbols: string[][];
    public avalancheRoundWin: number;
    public winRatio: number;
    public avalancheWinRatio: number;

    public isWin: boolean;
    public hasNoAvalancheWin: boolean;
    public splitOnReel: number[][];
    public xRevealTo: string = "";

    public nearWinReels: boolean[];
    public numberOfScattersOnReel: number[];
    public numberOfScattersOnReelPrev: number[];
    public dynamiteHitCoordinates: number[][];
    public fsSteps: IFSStepData[];
    public fsMultiplier: number;
    public linkedBombPositions: number[][];
    public linkedBombGroups: IWildMiningGroup[];

    constructor(api: ApiPlugin, triggerEvents: boolean = true) {
        super(api, triggerEvents);
        api.events.once("featureName", (data: string) => {
            this._buyFeatureName = data;
        });
        FireInTheHole2.apiPlugin.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            if (betData.type === APIBetType.FEATURE_BET && betData.featureName !== FireInTheHole2.boostedName) {
                FireInTheHole2.xBetController.selected = false;
            }
            for (let index = 0; index < FireInTheHole2.model.initData.featureBuyTimesBetValue.length; index++) {
                if (FireInTheHole2.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this._buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this._buyFeatureName);
                    break;
                }
            }
        });

        FireInTheHole2.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < FireInTheHole2.model.initData.featureBuyTimesBetValue.length; index++) {
                if (FireInTheHole2.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this._buyFeatureName = betData.featureName;
                    break;
                }
            }
        });
    }

    private checkAllWinPositions(clientData: boolean[][], serverData: boolean[][]): void {
        if (!serverData && this.isNextRespin) {
            Logger.logDev("no win data")
        }

        if (serverData.length === 0) {
            return
        }
        let c: boolean[][] = clientData.concat(), s: boolean[][] = serverData.concat();
        for (let i: number = 0; i < 6; i++) {
            const a: boolean[] = c[i].splice(0, (c[i].length - s[i].length));
            if (a.indexOf(true) > -1) {
                debugger;
                Logger.logDev(`wins is not the same on reel ${i}`)
            }
            if (c[i].join() != s[i].join()) {
                debugger;
                Logger.logDev(`wins is not the same on reel ${i}`)
            }
        }
    }

    private parseNearWinOnRestore(prevScatters: number[], wasFeatureBuy: boolean): boolean[] {
        const nearWinReels: boolean[] = ArrayHelper.initArrayWithValues(6, () => false);
        if (!this._isRestore || !this.isNextRespin || wasFeatureBuy) {
            return nearWinReels;
        }

        if (FITH2Helper.sum(prevScatters) >= 2) {
            this.reels.forEach((syms: string[], i: number) => {
                nearWinReels[i] = (prevScatters[i] < 2);
            });
        }

        return nearWinReels;
    }

    private parseNearWin(prevScatters: number[], newScatters: number[], wasFeatureBuy: boolean, isNormal: boolean): boolean[] {
        const nearWinReels: boolean[] = ArrayHelper.initArrayWithValues(6, () => false);
        if (!isNormal) {
            return nearWinReels;
        }

        let totalScatterNum: number = FITH2Helper.sum(prevScatters),
            hasTwoScatters: boolean = totalScatterNum >= 2;

        if (this.isLuckyDraw) {
            newScatters.forEach((num: number, i: number) => {
                nearWinReels[i] = (totalScatterNum >= 3);
                totalScatterNum += num;
            });

            return nearWinReels;
        }

        if (wasFeatureBuy) {
            return nearWinReels;
        }

        if (hasTwoScatters) {
            this.reels.forEach((syms: string[], i: number) => {
                nearWinReels[i] = (prevScatters[i] < 2);
            });
        } else {
            newScatters.forEach((num: number, i: number) => {
                totalScatterNum += (num - prevScatters[i]);
                nearWinReels[i] = hasTwoScatters;
                hasTwoScatters = (totalScatterNum >= 2);
            });
        }
        return nearWinReels;
    }

    private parseScatterNumberOnReels(reels: string[][], barId: number): number[] {
        const scatterNumberOnReels: number[] = [];
        reels.forEach((syms: string[]) => {
            let numberOfScatter: number = 0;

            syms.forEach((sym: string, i: number) => {
                if (i < barId) {
                    numberOfScatter += (sym === "S" ? 1 : 0);
                }
            });
            scatterNumberOnReels.push(numberOfScatter);
        });

        return scatterNumberOnReels;
    }

    private parseReelData(reels: string[][], barId: number): ISymbolData[][] {
        const reelsData: ISymbolData[][] = [];
        this.wildOnReel = ArrayHelper.initArrayWithValues(6, () => false);
        this.splitOnReel = [];
        reels.forEach((reel: string[], i: number) => {
            const reelData: ISymbolData[] = [];
            reel.forEach((symName: string, j: number) => {
                if (j < barId) {
                    if (symName[0] === "W") {
                        this.wildOnReel[i] = true;
                    }
                    if (symName === "X") {
                        this.splitOnReel.push([i, j]);
                    }
                }
                reelData.push({
                    symName: symName,
                    reelSize: 6,
                    symSize: 1,
                    id: j,
                    reelId: i
                });

            });
            reelsData.push(reelData);
        });
        return reelsData;
    }

    private parseRestoreReelData(removed: string[][], symbolSizes: number[][], bar: number, isFsRestore: boolean): ISymbolData[][] {
        const reelsData: ISymbolData[][] = [];
        this.wildOnReel = ArrayHelper.initArrayWithValues(6, () => false);
        this.splitOnReel = [];
        removed.forEach((reel: string[], i: number) => {
            const reelData: ISymbolData[] = [];
            reel.forEach((symName: string, j: number) => {
                if (j <= bar) {
                    if (symName[0] === "W") {
                        this.wildOnReel[i] = true;
                    }
                    if (symName === "X") {
                        this.splitOnReel.push([i, j]);
                    }
                }
                if (isFsRestore || (j > bar) || (j <= bar && !(symName === "BA" || symName === "M"))) {
                    reelData.push({
                        symName: symName,
                        reelSize: 6,
                        symSize: symbolSizes[i][j],
                        id: j,
                        reelId: i
                    });
                }
            });
            reelsData.push(reelData);
        });
        return reelsData;
    }

    private parseFSReelData(reels: string[][], evaluated: string[][], values: number[][], fsTriggerThisSpin: boolean): IFsSymbolData[][] {
        const reelsData: IFsSymbolData[][] = [];
        reels.forEach((reel: string[], i: number) => {
            const reelData: IFsSymbolData[] = [];
            let isFullFilled: boolean = true;
            reel.forEach((symName: string, j: number) => {
                const type = FITH2Helper.getSymbolType(symName),
                    addDirt: boolean = (fsTriggerThisSpin && j > 2);
                isFullFilled = (symName === "M" || symName === "H") ? false : isFullFilled;
                let value: number = values[i][j];
                if (j === 0) {
                    symName = evaluated[i][0];
                    value = (type === FSSymbolTypes.COLLECTOR || type === FSSymbolTypes.NECROMANCER) ? 0 : parseInt(symName.substring(symName[1] === "Y" ? 2 : 1));
                }
                reelData.push({
                    symName: addDirt ? "D" : symName,
                    value: value,
                    type: addDirt ? FSSymbolTypes.DIRT : type,
                    reelId: i,
                    id: j
                });

                if (evaluated[i][j] === "CO") {
                    this._hasChestOpen = true;
                }
            });
            reelsData.push(reelData);
            this.fsFullFilledReels.push(isFullFilled);
        });

        return reelsData;
    }

    private parseFillUpReelData(reelsData: ISymbolData[][], symbolSizes: number[][]): ISymbolData[][] {
        const newReelsData: ISymbolData[][] = [];
        reelsData.forEach((reelData: ISymbolData[], i: number) => {
            const newReelData: ISymbolData[] = [];
            reelData.forEach((data: ISymbolData, j: number) => {
                newReelData.push({
                    symName: data.symName,
                    reelSize: 6,
                    symSize: 1,
                    id: j,
                    reelId: i
                });
            });
            newReelsData.push(newReelData);
        });
        return newReelsData;
    }

    private parseAllWinPositions(reels: string[][], betWayWinData: IBetWayWinData[]): boolean[][] {
        const winPositions: boolean[][] = ArrayHelper.initArrayWithValues(6, () => {
            return ArrayHelper.initArrayWithValues(6, () => false);
        });
        const allWinPositionSymbols: string[][] = ArrayHelper.initArrayWithValues(6, () => {
            return ArrayHelper.initArrayWithValues(6, () => "");
        });
        this.maxWinReelId = -1;
        betWayWinData.forEach((betWayWin: IBetWayWinData) => {
            const winSym: string = betWayWin.symbol;
            this.maxWinReelId = Math.max(this.maxWinReelId, betWayWin.length);
            let reelWinPositions: boolean[][] = ArrayHelper.initArrayWithValues(6, () => {
                return ArrayHelper.initArrayWithValues(6, () => false);
            });

            reels.forEach((reel: string[], i: number) => {
                if (i <= betWayWin.length) {
                    reel.forEach((symName: string, j: number) => {
                        if (symName === winSym || FITH2Helper.isWild(symName)) {
                            winPositions[i][j] = true;
                            allWinPositionSymbols[i][j] = symName;
                            reelWinPositions[i][j] = true;
                        }
                    });
                }
            });
            betWayWin.reelWinPositions = reelWinPositions;
        });
        this.allWinPositionSymbols = allWinPositionSymbols;
        return winPositions;
    }

    private findHorizontal(groups: IWildMiningGroup[], reels: string[][],): void {
        let result: number[][] = [];
        const numRows: number = reels[0].length;
        const numCols: number = reels.length;
        for (let symId = 0; symId < numRows; symId++) {
            let currentLetter = "";
            let currentCount = 0;
            let startIndex = -1, endIndex = -1;
            for (let reelId = 0; reelId < numCols; reelId++) {
                let sym: string = reels[reelId][symId];
                if (sym == "X") {
                    sym = this.xRevealTo
                }
                if (sym === currentLetter) {
                    currentCount++;
                    endIndex = reelId;
                } else {
                    result = [];
                    if (currentCount > 2 && currentLetter[0] !== "D") {
                        break;
                    } else {
                        currentLetter = (reels[reelId][symId] === "X") ? this.xRevealTo : reels[reelId][symId];
                    }
                    startIndex = reelId;
                    currentCount = 1;
                }
            }
            result = [];
            if (currentCount > 2 && currentLetter[0] !== "W" &&currentLetter[0] !== "D" && currentLetter[0] !== "S") {
                for (let k = startIndex; k <= endIndex; k++) {
                    result.push([k, symId]);
                }
                groups.push({
                    linkedSymbol: currentLetter,
                    symbols: result
                });
            }
        }
    }

    private findVertical(groups: IWildMiningGroup[], reels: string[][]): void {
        let result: number[][] = [];
        const numRows: number = reels[0].length;
        const numCols: number = reels.length;
        for (let reelId = 0; reelId < numCols; reelId++) {
            let currentLetter = "";
            let currentCount = 0;
            let startIndex = -1, endIndex: number = -1;

            for (let symId = 0; symId < numRows; symId++) {
                let sym: string = reels[reelId][symId];
                if (sym == "X") {
                    sym = this.xRevealTo
                }
                if (sym === currentLetter) {
                    currentCount++;
                    endIndex = symId;
                } else {
                    if (currentCount > 2 && currentLetter[0] !== "D") {
                        break;
                    } else {
                        currentLetter = (reels[reelId][symId] === "X") ? this.xRevealTo : reels[reelId][symId];
                    }
                    currentCount = 1;
                    startIndex = symId;
                }
            }
            result = [];
            if (currentCount > 2 && currentLetter[0] !== "W" && currentLetter[0] !== "D" && currentLetter[0] !== "S") {
                for (let k = startIndex; k <= endIndex; k++) {
                    result.push([reelId, k]);
                }
                groups.push({
                    linkedSymbol: currentLetter,
                    symbols: result
                });
            }
        }
    }

    private findLinkedGroups(reels: string[][], bombs: number[][]): IWildMiningGroup[] {
        const groups: IWildMiningGroup[] = [], xBomb: number[][] = bombs.concat();
        this.findHorizontal(groups, reels);
        this.findVertical(groups, reels);

        return groups;
    }

    private parseLinkedBombPositions(gameReels: string[][], spinsPlayed: number, removedSymbols: string[][]): number[][] {
        const bombPos: number[][] = [],
            reels: string[][] = ArrayHelper.initArrayWithValues(6, (i: number) => {
                return gameReels[i].slice(0, Math.min(6, 3 + spinsPlayed - 1))
            }),
            removed: string[][] = ArrayHelper.initArrayWithValues(6, (i: number) => {
                return removedSymbols[i].slice(0, Math.min(6, 3 + spinsPlayed - 1))
            });
        removed.forEach((reel: string[], i: number) => {
            reel.forEach((sym: string, j: number) => {
                if (sym === "W" && !FITH2Helper.isWild(reels[i][j])) {
                    bombPos.push([i, j]);
                }
            });
        });
        this.linkedBombGroups = this.findLinkedGroups(reels, bombPos);
        return bombPos;
    }

    private parseTotalWays(gameReels: string[][], spinsPlayed: number, symbolSizes: number[][]): number {
        let ways: number = 1;
        spinsPlayed = Math.min(spinsPlayed, 4);
        for (let i: number = 0; i < 6; i++) {
            let symCount: number = 0;
            for (let j: number = 0; j < (spinsPlayed + 2); j++) {
                if (!(FITH2Helper.isInvisibleSym(gameReels[i][j]) || gameReels[i][j][0] === "D")) {
                    symCount += symbolSizes[i][j];
                }
            }
            ways *= (Math.max(1, symCount));
        }

        return ways;
    }

    private parseCoinCollectorStep(i: number, collectorPos: number[], endMultipliers: number[][], coinTypes: string[][]): IFSStepData {
        let totalCoin: number = 0;
        endMultipliers.forEach((coin: number[]) => {
            totalCoin += FITH2Helper.sum(coin);
        });
        endMultipliers[collectorPos[0]][collectorPos[1] - 1] = totalCoin;

        return {
            id: i,
            collectorPos: collectorPos,
            endMultipliers: FITH2Helper.copyNumberArray(endMultipliers),
            coinTypes: FITH2Helper.copyArray(coinTypes)
        };
    }

    private parseReelMultiplierStep(i: number, value: number, multiplierPos: number[], endMultipliers: number[][], coinTypes: string[][]): IFSStepData {
        endMultipliers[multiplierPos[0]].forEach((multiplier: number, symId: number) => {
            endMultipliers[multiplierPos[0]][symId] *= value;

        });

        return {
            id: i,
            reelMultiplier: {
                multiplier: value,
                reelId: multiplierPos[0],
                rId: multiplierPos[1]
            },
            endMultipliers: FITH2Helper.copyNumberArray(endMultipliers),
            coinTypes: FITH2Helper.copyArray(coinTypes)
        };
    }

    private parseDynamiteStep(i: number, dynamitePos: number[], throwPositions: number[][], endMultipliers: number[][], coinTypes: string[][]): IFSStepData {
        throwPositions.forEach((pos: number[]) => {
            //not a chest
            if (pos[1] < 5) {
                endMultipliers[pos[0]][pos[1] - 1] *= 2;
            }
        });

        return {
            id: i,
            dynamites: {
                dynamitePos: dynamitePos,
                throwPos: throwPositions
            },
            endMultipliers: FITH2Helper.copyNumberArray(endMultipliers),
            coinTypes: FITH2Helper.copyArray(coinTypes)
        };
    }

    private parseFSSteps(data: IFITH2GameData): IFSStepData[] {
        let reels: string[][] = data.reels, reelsAfterCollapse: string[][] = data.reelsAfterCollapse,
            coinValuesBefore: number[][] = data.coinValuesPreviousSpin,
            dynamitePositions: number[][] = data.dynamiteHitCoordinates, steps: IFSStepData[] = [],
            endMultipliers: number[][] = ArrayHelper.initArrayWithValues(6, (s: number) => {
                const values: number[] = [],
                    reel: string[] = reels[s].slice(1, 5);
                reel.forEach((sym: string, symId: number) => {
                    const topSym: string = reelsAfterCollapse[s][0];
                    let topValue: number = 0;
                    if (topSym === "N" || topSym[0] === "R") {
                        topValue = (coinValuesBefore[s][symId + 1] > 0 ? 0 : 1);
                    } else if (topSym === "DC") {
                        topValue = 0;
                    } else {
                        topValue = parseInt(topSym.match(/\d+/)![0]);
                    }
                    values.push(coinValuesBefore[s][symId + 1] + (sym == "H" ? topValue : 0));
                })
                return values;
            }),
            coinTypes: string[][] = ArrayHelper.initArrayWithValues(6, (s: number) => {
                const temp: string[] = reelsAfterCollapse[s].slice(1, 5);
                temp.forEach((symName: string, t: number) => {
                    temp[t] = symName;
                });
                return temp;
            }),
            usedDynamites: number = 0,
            stepId: number = 0,
            beerId: number = 0;
        reelsAfterCollapse.forEach((reel: string[], i: number) => {
            for (let j: number = 1; j < 5; j++) {
                const sym: string = reel[j];
                if (FITH2Helper.isDynamite(sym)) {
                    const dynamites: number = parseInt(sym.slice(-1)),
                        step: IFSStepData = this.parseDynamiteStep(stepId, [i, j], dynamitePositions.slice(usedDynamites, usedDynamites + dynamites), endMultipliers, coinTypes);
                    usedDynamites += dynamites;
                    steps.push(step);
                    coinTypes[i][j - 1] = (sym[0] === "P" ? sym : "C");
                    stepId++;
                }

                if (FITH2Helper.isCollector(sym)) {
                    const step: IFSStepData = this.parseCoinCollectorStep(stepId, [i, j], endMultipliers, coinTypes);
                    steps.push(step);
                    coinTypes[i][j - 1] = (sym[0] === "P" ? sym : "C");
                    stepId++;
                }

                if (sym[0] === "R" || (sym.slice(0, 2) === "PR")) {
                    const step: IFSStepData = this.parseReelMultiplierStep(stepId, parseInt(sym.replace(/^\D+/g, '')), [i, j - 1], endMultipliers, coinTypes);
                    steps.push(step);
                    coinTypes[i][j - 1] = (sym[0] === "P" ? "PC" : "C");
                    stepId++;
                }

                if (sym[0] === "N" || (sym.slice(0, 2) === "PN")) {
                    steps.push({
                        id: stepId,
                        necromancer: {
                            necromancerPos: [i, j],
                            necromancerHitPos: data.necromancerHitCoordinates[beerId]
                        },
                        endMultipliers: FITH2Helper.copyNumberArray(endMultipliers),
                        coinTypes: FITH2Helper.copyArray(coinTypes)
                    });
                    coinTypes[i][j - 1] = (sym[0] === "P" ? sym : "C");
                    stepId++;
                    beerId++;
                }
            }
        });

        if (NolimitConfig.isDevMode) {
            steps.forEach((step: IFSStepData) => {
                console.log(`step: ${step.id}, multis: ${step.endMultipliers}, types: ${step.coinTypes}`);
            });
            for (let i: number = 0; i < endMultipliers.length; i++) {
                for (let j: number = 0; j < endMultipliers[i].length; j++) {
                    if (endMultipliers[i][j] !== this.data.coinValues[i][j + 1]) {
                        debugger
                    }
                }
            }
        }
        return steps;
    }

    private calCoinValue(coinValue: number[][]): number {
        const reelValue: number[] = ArrayHelper.initArrayWithValues(6, (i: number) => {
            const value: number = FITH2Helper.sum(coinValue[i]);
            return value;
        })
        return FITH2Helper.sum(reelValue);
    }

    protected onInit(data: IFITH2InitData): void {
        super.onInit(data);
        this._isRestore = data.isRestoreState;
        this.nextPlayerInteraction = data.nextPlayerInteraction;
        this.boostedBet = (data.boostedBet || (data.nextPlayerInteraction?.featureName != undefined && data.nextPlayerInteraction.featureName === FireInTheHole2.boostedName));
        if (data.nextPlayerInteraction?.featureName != undefined) {
            this._buyFeatureName = data.nextPlayerInteraction.featureName;
        }
        this._isBigWin = false;
        this._isNormal = FITH2Helper.isNormal(data.mode);
        this._isNextNormal = FITH2Helper.isNormal(data.nextMode);
        this._isRespin = FITH2Helper.isRespin(data.mode);
        this._isNextRespin = FITH2Helper.isRespin(data.nextMode);
        this._hasChestOpen = false;
        this.splitOnReel = [];
        this.wildOnReel = [];
        this.fsSteps = [];
        this.freespinTriggeredThisSpin = this._isNormal && data.nextMode[0] === "F";
        const normalSpinsPlayed: number = data.totalSpinsPlayed - data.freespinsPlayed,
            barId: number = Math.min(6, 2 + (normalSpinsPlayed - (this._isNextRespin ? 0 : 1)));
        this.reels = FITH2Helper.copyArray(data.reels);

        if (this._isNormal && this._isRestore) {
            const isFsRestore: boolean = (data.mode[0] === "F" || data.nextMode[0] === "F");
            this.reelsData = this.parseRestoreReelData(data.removedSymbols, data.symbolSizes, barId, isFsRestore);
        } else {
            this.reelsData = this.parseReelData(this._isNormal ? data.reels : data.beforeFreespinsArea, barId);
        }
        this.xRevealTo = "";
        this.barId = barId;
        this.fsFullFilledReels = [];
        this.fsReelsData = this._isNormal ? this.defaultFSReelData : this.parseFSReelData(data.reels, data.reels, data.coinValues, this.freespinTriggeredThisSpin);
        this.numberOfScattersOnReelPrev = ArrayHelper.initArrayWithValues(6, () => 0);
        this.numberOfScattersOnReel = this.parseScatterNumberOnReels(data.reels, barId);
        this.nearWinReels = this.parseNearWinOnRestore(this.numberOfScattersOnReel, data.wasFeatureBuy);
        this.maxWinReelId = -1;
        this.fsMultiplier = (this._isNormal ? 0 : this.calCoinValue(data.coinValues));
        this.totalWays = this._isRestore ? this.parseTotalWays(this._isNormal ? data.reels : data.beforeFreespinsArea, barId, data.symbolSizes) : FITH2GameConfig.DEFAULT_WAYS;
        if (this._isRestore && FITH2Helper.isRespin(data.nextMode)) {
            this.numberOfScattersOnReelPrev = this.numberOfScattersOnReel.concat();
        }
    }

    public onGame(data: IFITH2GameData): void {
        super.onGame(data);
        this._isNormal = FITH2Helper.isNormal(data.mode);
        this._isNextNormal = FITH2Helper.isNormal(data.nextMode);
        this._isRespin = FITH2Helper.isRespin(data.mode);
        this._isNextRespin = FITH2Helper.isRespin(data.nextMode);
        this._hasChestOpen = false;
        if (this._isNormal) {
            this.boostedBet = data.boostedBet;
        }
        this.hasNoAvalancheWin = (data.totalSpinWinnings === 0);
        this.freespinTriggeredThisSpin = this._isNormal && data.nextMode[0] === "F";

        this.splitOnReel = [];
        this.wildOnReel = [];
        this.dynamiteHitCoordinates = [];
        this.fsSteps = [];
        this.reels = FITH2Helper.copyArray(data.reels);
        const barId: number = Math.min(6, 2 + data.totalSpinsPlayed - data.freespinsPlayed);
        if (!this.isRestore) {
            this.numberOfScattersOnReel = this.parseScatterNumberOnReels(data.reels, barId);
            this.nearWinReels = this.parseNearWin(this.numberOfScattersOnReelPrev, this.numberOfScattersOnReel, data.wasFeatureBuy, this._isNormal);
        }
        this._isRestore = false;
        this.barId = barId;
        this.reelsData = this.parseReelData(this.reels, barId);
        this.xRevealTo = (this.splitOnReel.length > 0 ? data.evaluatedArea[this.splitOnReel[0][0]][this.splitOnReel[0][1]] : "");
        this.fsFullFilledReels = [];
        this.fsReelsData = this.isNormal ? this.defaultFSReelData : this.parseFSReelData(this.reels, data.evaluatedArea, data.coinValues, this.freespinTriggeredThisSpin);

        this.reelsFillUpData = this.parseFillUpReelData(this.reelsData, data.symbolSizes);
        this.numberOfScattersOnReelPrev = this._isNextRespin ? this.parseScatterNumberOnReels(data.removedSymbols, barId + 1) : [0, 0, 0, 0, 0, 0];

        this.allWinPositionSymbols = [];
        this.allWinPositions = this.parseAllWinPositions(data.evaluatedArea, data.betWayWins);
        this.avalancheRoundWin = data.totalSpinWinnings;
        this.winRatio = MathHelper.roundToDecimals(data.accumulatedRoundWin / data.playedBetValue, 1);
        this.currentWinRatio = MathHelper.roundToDecimals(data.accumulatedRoundWin / data.playedBetValue, 1);
        this.avalancheWinRatio = MathHelper.roundToDecimals(data.accumulatedRoundWin / data.playedBetValue, 1);
        this.isWin = data.accumulatedRoundWin > 0 && !this._isNextRespin && this._isRespin;
        this._isBigWin = (data.nextMode === GameMode.NORMAL) && FITH2Helper.isBigWin(data.mode[0] === "F" ? data.accumulatedFSRoundWin : data.accumulatedRoundWin, this.gameData.playedBetValue);

        this.linkedBombPositions = [];
        this.linkedBombGroups = [];
        if (data.wildMiningTriggered) {
            this.linkedBombPositions = this.parseLinkedBombPositions(data.evaluatedArea, data.totalSpinsPlayed, data.removedSymbols);
        }
        if (this._isNormal) {
            this.totalWays = this.parseTotalWays(data.reels, data.totalSpinsPlayed, data.symbolSizes);
        } else {
            this.dynamiteHitCoordinates = data.dynamiteHitCoordinates.concat();
            this.fsSteps = this.parseFSSteps(data);
        }
        this.fsMultiplier = (this._isNormal ? 0 : (data.brokeTheBank ? FITH2GameConfig.WIN_CAP : (this.calCoinValue(data.coinValues))));
        if (NolimitConfig.isDevMode) {
            //this.checkAllWinPositions(this.allWinPositions, data.position);
        }
    }

    public get isNormal(): boolean {
        return this._isNormal;
    }

    public get isRespin(): boolean {
        return this._isRespin;
    }

    public get isNextNormal(): boolean {
        return this._isNextNormal;
    }

    public get isNextRespin(): boolean {
        return this._isNextRespin;
    }

    public get isRestore(): boolean {
        return this._isRestore;
    }

    public get hasChestOpen(): boolean {
        return this._hasChestOpen;
    }

    public get buyFeatureName(): string {
        return this._buyFeatureName;
    }

    public get isLuckyDraw(): boolean {
        return this._buyFeatureName === "LUCKY_DRAW";
    }

    public get isBigWin(): boolean {
        return this._isBigWin;
    }

    public get defaultFSReelData(): IFsSymbolData[][] {
        const fakeTopTrain: string[] = ["DY5", "DC", "C100", "R25", "N", "C50"],
            reelsData: IFsSymbolData[][] = [],
            defaults: string[] = ArrayHelper.initArrayWithValues(6, () => "M"),
            reels: string[][] = ArrayHelper.initArrayWithValues(6, () => defaults);
        reels.forEach((reel: string[], i: number) => {
            const reelData: IFsSymbolData[] = [];
            reel.forEach((symName: string, j: number) => {
                reelData.push({
                    symName: (j === 0 ? fakeTopTrain[i] : (j == 5 ? "CC" : (j > 2 ? "D" : "M"))),
                    value: -1,
                    type: (j > 2 && j < 5) ? FSSymbolTypes.DIRT : FSSymbolTypes.MISS,
                    id: j,
                    reelId: i
                });
            });
            reelsData.push(reelData);
        });
        return reelsData;
    }
}